/* istanbul ignore file */

import { createContext, useContext } from 'react'
import { EppoClient } from '@eppo/js-client-sdk-common'
import { Store } from '@moonpig/web-core-types'

type DefaultSubjectAttributes = {
  storeId: Store['id']
  loggedIn: boolean
}

export const EppoContext = createContext<{
  client: EppoClient
  defaultSubjectAttributes: DefaultSubjectAttributes
} | null>(null)

export const useEppoClient = () => useContext(EppoContext)?.client
export const useEppoDefaultSubjectAttributes = () =>
  useContext(EppoContext)?.defaultSubjectAttributes
